module.exports = __webpack_public_path__ + "static/media/51_tn.367bdb33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/51_tn.jpg
// module id = 687
// module chunks = 0